const { number_format } = require('../utils/common');

// comment에서 <style> 태그를 모두 제거하는 함수
const getViewComment = (comment) => {
  if (!comment) return '';
  let html = comment;

  console.log('--------------------------- view comment ---------------------------');
  console.log(html);

  // <style> 태그 모두 제거
  html = html.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');

  // HTML 엔티티를 원래 기호로 복원
  html = html.replace(/&amp;/g, '&');
  html = html
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');

  console.log(html);
  
  html = html.replace(/https:\/\/www\.klata\.or\.kr\/image\/nav\/footer_ci\.png/g, '/image/nav/footer_ci.png');
  html = html.replace(/\/image\/nav\/footer_ci\.png/g, 'https://www.klata.or.kr/image/nav/footer_ci.png');

  html = html.replace(/\/\/dev-www\.klata\.or\.kr\/cdn\/klata\/file\//g, 'https://www.klata.or.kr/cdn/klata/file/');

  // "" → "로 변경 (특수한 경우)
  html = html.replace(/""/g, '"');

  console.log(html);

  return html;
};

const getJoinComment = (name, birth, handphone, place, type, price, signImage) => {
  let duty;
  if (parseInt(type) === 1) duty = '총감독위원';
  else if (parseInt(type) === 2) duty = '시험감독관(정)';
  else if (parseInt(type) === 3) duty = '시험감독관(부)';
  else if (parseInt(type) === 4) duty = '보조감독관';
  else if (parseInt(type) === 5) duty = '통제위원';
  else if (parseInt(type) === 6) duty = '관리위원';
  else duty = '기타';

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();

  let html = `
  &amp;lt;h1&amp;gt;시험감독위원 취임ㆍ서약서 및 영수증&amp;lt;/h1&amp;gt;
    &amp;lt;table&amp;gt;
      &amp;lt;tbody&amp;gt;&amp;lt;tr&amp;gt;
        &amp;lt;th&amp;gt;시 험 장 : &amp;lt;/th&amp;gt;
        &amp;lt;td&amp;gt;${place}&amp;lt;/td&amp;gt;
        &amp;lt;th&amp;gt;성      명 : &amp;lt;/th&amp;gt;
        &amp;lt;td&amp;gt;${name}&amp;lt;/td&amp;gt;
      &amp;lt;/tr&amp;gt;
      &amp;lt;tr&amp;gt;
        &amp;lt;th&amp;gt;생년월일 : &amp;lt;/th&amp;gt;
        &amp;lt;td&amp;gt;${birth}&amp;lt;/td&amp;gt;
        &amp;lt;th&amp;gt;연 락 처 : &amp;lt;/th&amp;gt;
        &amp;lt;td&amp;gt;${handphone}&amp;lt;/td&amp;gt;
      &amp;lt;/tr&amp;gt;
      &amp;lt;tr&amp;gt;
        &amp;lt;td colspan=&amp;quot;4&amp;quot;&amp;gt;위 본인은 ${duty}으로 취임함에 있어 사단법인 한국국어능력평가협회 시험 규정에 따라 시험 관리와 감독 업무를 성실히 수행할 것을 서약합니다.&amp;lt;/td&amp;gt;
      &amp;lt;/tr&amp;gt;
    &amp;lt;/tbody&amp;gt;&amp;lt;/table&amp;gt;
    &amp;lt;table&amp;gt;
      &amp;lt;tbody&amp;gt;&amp;lt;tr&amp;gt;
        &amp;lt;th&amp;gt;감독료 :&amp;lt;/th&amp;gt;
        &amp;lt;td&amp;gt;일금 정(￦${number_format(price)})&amp;lt;/td&amp;gt;
      &amp;lt;/tr&amp;gt;
      &amp;lt;tr&amp;gt;
        &amp;lt;th colspan=&amp;quot;2&amp;quot;&amp;gt;상기 금액을 정히 영수함&amp;lt;/th&amp;gt;
      &amp;lt;/tr&amp;gt;
    &amp;lt;/tbody&amp;gt;&amp;lt;/table&amp;gt;
    &amp;lt;table&amp;gt;
      &amp;lt;tbody&amp;gt;&amp;lt;tr&amp;gt;
        &amp;lt;th&amp;gt;${year}년 ${month}월 ${day}일&amp;lt;/th&amp;gt;
      &amp;lt;/tr&amp;gt;
      &amp;lt;tr&amp;gt;
        &amp;lt;th&amp;gt;서 약 인 : ${name}&amp;lt;img src=&amp;quot;${signImage}&amp;quot; class=&amp;quot;signature&amp;quot;/&amp;gt;&amp;lt;/th&amp;gt;
      &amp;lt;/tr&amp;gt;
      &amp;lt;tr&amp;gt;
        &amp;lt;td&amp;gt;&amp;lt;img src=&amp;quot;https://www.klata.or.kr/image/nav/footer_ci.png&amp;quot; alt=&amp;quot;&amp;quot; style=&amp;quot;width:200px;height:auto;&amp;quot;&amp;gt;&amp;lt;/td&amp;gt;
  `;

  return html;
};

module.exports = {
  getViewComment,
  getJoinComment,
};